/**
 * @generated SignedSource<<416be24faf2633db8bf06ec26b229e8f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksWaitForSellerExists_checkSellerExistsQuery$variables = Record<PropertyKey, never>;
export type hooksWaitForSellerExists_checkSellerExistsQuery$data = {
  readonly existsCurrentSellerOnIntegrationService: boolean;
  readonly existsCurrentSellerOnMarketingService: boolean;
  readonly existsCurrentSellerOnMarketplaceIntegrationService: boolean;
  readonly existsCurrentSellerOnOrderService: boolean;
  readonly existsCurrentSellerOnSalesChannelService: boolean;
  readonly existsCurrentSellerOnSellerSettings: boolean;
  readonly existsCurrentSellerOnSubscriptionService: boolean;
};
export type hooksWaitForSellerExists_checkSellerExistsQuery = {
  response: hooksWaitForSellerExists_checkSellerExistsQuery$data;
  variables: hooksWaitForSellerExists_checkSellerExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnSubscriptionService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnIntegrationService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnSalesChannelService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnMarketplaceIntegrationService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnMarketingService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnOrderService",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "existsCurrentSellerOnSellerSettings",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "d710c72bf7426da0c6008b00977d851f",
    "id": null,
    "metadata": {},
    "name": "hooksWaitForSellerExists_checkSellerExistsQuery",
    "operationKind": "query",
    "text": "query hooksWaitForSellerExists_checkSellerExistsQuery {\n  existsCurrentSellerOnSubscriptionService\n  existsCurrentSellerOnIntegrationService\n  existsCurrentSellerOnSalesChannelService\n  existsCurrentSellerOnMarketplaceIntegrationService\n  existsCurrentSellerOnMarketingService\n  existsCurrentSellerOnOrderService\n  existsCurrentSellerOnSellerSettings\n}\n"
  }
};
})();

(node as any).hash = "8aeb7e0a81ababd3835286b9bc509f6e";

export default node;
